{
  "success": {
    "default": "Opération réussie",
    "save": "Sauvegardé",
    "remove": "Suppression effectuée",
    "detach": {
      "user": "L'utilisateur suivant a bien été détaché du secteur { sectorName } | Les utilisateurs suivant ont bien été détachés du secteur { sectorName }",
      "device": "L'équipement suivant a bien été détaché du secteur { sectorName } | Les équipements suivant ont bien été détachés du secteur { sectorName }",
      "application": "l'applicatif suivant a bien été détaché du secteur { sectorName } | Les applicatifs suivant ont bien été détachés du secteur { sectorName }",
      "userGroup": "Le groupe d'utilisateur suivant a bien été détaché du secteur { sectorName } | Les groupes d'utilisateurs suivant ont bien été détachés du secteur { sectorName }",
      "dtwins": "L'équipement suivant a bien été détaché du secteur { sectorName } | Les équipements suivant ont bien été détachés du secteur { sectorName }"
    },
    "attach": {
      "user": "L'utilisateur suivant a bien été attaché au secteur { sectorName } | Les utilisateurs suivant ont bien été attachés au secteur { sectorName }",
      "device": "L'équipement suivant a bien été attaché au secteur { sectorName } | Les équipements suivant ont bien été attachés au secteur { sectorName }",
      "application": "l'applicatif suivant a bien été attaché au secteur { sectorName } | Les applicatifs suivant ont bien été attachés au secteur { sectorName }",
      "userGroup": "Le groupe d'utilisateur suivant a bien été attaché au secteur { sectorName } | Les groupes d'utilisateurs suivant ont bien été attachés au secteur { sectorName }",
      "dtwins": "L'équipement suivant a bien été attaché au secteur { sectorName } | Les équipements suivant ont bien été attachés au secteur { sectorName }"
    },
    "certificate": {
      "generation": "La génération du certificat d’utilisateur s’est correctement terminée."
    }
  },
  "cancellation": {
    "cancel": "Modifications annulées"
  },
  "inProgress": {
    "save": "Sauvegarde en cours"
  },
  "error": {
    "default": "Une erreur s'est produite",
    "unexpectedApiError": "Une erreur imprévue est survenue",
    "save": "Échec de la sauvegarde",
    "remove": "La suppression a échoué",
    "upload": "L’import a échoué, veuillez recommencer",
    "detach": {
      "user": "Le détachement du secteur { sectorName } de l'utilisateur suivant a échoué | Les détachements au secteur { sectorName } des utilisateurs suivant ont échoués",
      "device": "Le détachement du secteur { sectorName } de l'équipement suivant a échoué | Les détachements au secteur { sectorName } des équipements suivant ont échoués",
      "application": "Le détachement du secteur { sectorName } de l'application suivant a échoué | Les détachements au secteur { sectorName } des applications suivant ont échoués",
      "userGroup": "Le détachement du secteur { sectorName } du groupe d'utilisateurs suivant a échoué | Les détachements au secteur { sectorName } des groupes utilisateurs suivant ont échoués",
      "dtwins": "Le détachement du secteur { sectorName } de l'équipement suivant a échoué | Les détachements au secteur { sectorName } des équipements suivant ont échoués"
    },
    "attach": {
      "user": "L'attachement au secteur { sectorName } de l'utilisateur suivant a échoué | Les attachements au secteur { sectorName } des utilisateurs suivant ont échoués",
      "device": "L'attachement au secteur { sectorName } de l'équipement suivant a échoué | Les attachements au secteur { sectorName } des équipements suivant ont échoués",
      "application": "L'attachement au secteur { sectorName } de l'application suivant a échoué | Les attachements au secteur { sectorName } des applications suivant ont échoués",
      "userGroup": "L'attachement au secteur { sectorName } du groupe d'utilisateurs suivant a échoué | Les attachements au secteur { sectorName } des groupes utilisateurs suivant ont échoués",
      "dtwins": "L'attachement au secteur { sectorName } de l'équipement suivant a échoué | Les attachements au secteur { sectorName } des équipements suivant ont échoués"
    },
    "campaign": {
      "firmware": "La mise à jour du firmware n'a pu être programmée à la date voulue"
    },
    "startDate": "La campagne a déjà commencé, vous ne pouvez pas modifier les dates de début et de fin.",
    "keystore": {
      "aliasAlreadyUsed": {
        "title": "L'alias est déjà utilisé",
        "message": "Choisissez un autre alias et recommencez."
      }
    },
    "certificate": {
      "parsing": "Erreur de certificat",
      "notValid": "Le certificat de l'API n'est pas valide"
    }
  }
}
